import { Box } from '@mui/material';
import type { GridValidRowModel } from '@mui/x-data-grid';
import { ResourceTable, type ResourceTableProps, type ResourceTableState } from './ResourceTable';

export type ResourceCollectionState = ResourceTableState;

export type ResourceCollectionProps<Row extends GridValidRowModel> = ResourceTableProps<Row> & {
  state: ResourceCollectionState;
  minHeight?: number | string;
};

export function ResourceCollection<Row extends GridValidRowModel>({
  state,
  minHeight = 320,
  ...tableProps
}: ResourceCollectionProps<Row>) {
  return <Box sx={{ flex: '1 1 auto', height: '100%', minHeight, minWidth: 0 }}>
    <ResourceTable {...tableProps} state={state} />
  </Box>;
}
